var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pt-12"},[_c('v-col',{staticStyle:{"align-self":"start"}},[_c('app-pdf-preview',{attrs:{"value":_vm.loading,"queryParams":_vm.$route.query},on:{"loadDone":_vm.onLoadDone}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }